// src/PrivacyPolicy.js
import React from "react";

function PrivacyPolicy() {
  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
      <h1>Privacy Policy</h1>
      <p>
        Thank you for using "iLoveScan: AI PDF Editor Scan" (the "App"). Your
        privacy is important to us. This Privacy Policy explains how we collect,
        use, and protect your information when you use the App.
      </p>

      <h2>1. Information We Collect</h2>
      <p>
        We do not collect any personal information from you. The App does not
        gather or store any information about you or your usage.
      </p>

      <h2>2. Usage of the App</h2>
      <p>
        The App is designed to provide fast and efficient text scanning and
        document reading capabilities, including PDFs, Excel files, and other
        document types. To offer these features, the App accesses the images in
        your gallery and the documents you choose to open. This data is used
        solely for the purpose of the App's functionality and is not stored or
        shared.
      </p>

      <h2>3. Data Storage and Sharing</h2>
      <p>
        We do not store any of your images, documents, or any other personal
        data. All data processed by the App is handled locally on your device
        and is not shared with third parties.
      </p>

      <h2>4. Security</h2>
      <p>
        We prioritize your security and implement appropriate technical and
        organizational measures to protect the data processed by the App.
        However, please be aware that no method of transmission over the
        internet or electronic storage is 100% secure.
      </p>

      <h2>5. Free and Easy to Use</h2>
      <p>
        The App is free to use and does not include any payments. It is designed
        to be user-friendly and efficient, ensuring a smooth experience without
        any data collection.
      </p>

      <h2>6. Changes to This Privacy Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Any changes will be
        posted on this page with an updated effective date. We encourage you to
        review this Privacy Policy periodically to stay informed about how we
        are protecting your information.
      </p>

      <h2>7. Contact Us</h2>
      <p>
        If you have any questions about this Privacy Policy or the practices of
        the App, please contact us at:
      </p>
      <p>
        Email:
        <a href="mailto:trusticalabs@gmail.com">trusticalabs@gmail.com</a>
      </p>

      <h2>8. Consent</h2>
      <p>By using the App, you consent to our Privacy Policy.</p>
    </div>
  );
}

export default PrivacyPolicy;
